import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import classes from './NumberFormat.scss';

export const FORMAT_NUMBER  = 'number';
export const FORMAT_PERCENT = 'percent';
export const FORMAT_CURRENCY = 'currency';
export const DEFAULT_PRECISION = 2;
export const THOUSANDS_SEPARATOR = ' ';

// from https://stackoverflow.com/a/10899795/2821101
const THOUSANDS_REGEXP = /\B(?=(\d{3})+(?!\d))/g;

export function formatNumber(number, format = FORMAT_NUMBER, precision = DEFAULT_PRECISION, separator = THOUSANDS_SEPARATOR) {
  if( isNaN(Number(number)) || number === null ) {
    return '—';
  }

  let formattedNumber = Number(number).toFixed(precision);
  const parts = formattedNumber.split('.');

  formattedNumber = parts[0].replace(THOUSANDS_REGEXP, separator) + (parts[1] ? '.' + parts[1] : '');

  switch (format) {
    case FORMAT_NUMBER:
    default:
      return formattedNumber;
    case FORMAT_PERCENT:
      return formattedNumber + '\xa0%';
  }
}

/**
 * Форматированный вывод числа. Может быть представлено в виде числа, процента или суммы в валюте.
 */
export default function NumberFormat({ number, suffix, currency, format, precision, separator, formatter, prefix, className = '' }) {
  const currencyById = useSelector(state => state.currency.currencyById[currency] || {});

  if(typeof formatter === 'function'){
    number = formatter(number);
  }

  const formattedNumber = formatNumber(number, format, precision, separator);

  if (format === FORMAT_CURRENCY) {
    if (typeof currency === 'number') {
      suffix = currencyById.name || '';
    } else {
      suffix = currency || '';
    }
  }

  return (
    <span className={classNames(classes.numberFormat, className)}>
      {prefix ? prefix + ' ' : false}
      {formattedNumber}
      {suffix ?
        (
          <>
            {' '}
            <span className="ca-number-format__suffix">{suffix}</span>
          </>
        )
        :
        null
      }
    </span>
  );
}

NumberFormat.propTypes = {
  number: PropTypes.number,
  format: PropTypes.oneOf([FORMAT_NUMBER, FORMAT_PERCENT, FORMAT_CURRENCY]),
  formatter: PropTypes.func,
  precision: PropTypes.number,
  separator: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  currency: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
}
